import { track } from '@bnnvara/analytics/src/track';
import { ArrowDown } from '@bnnvara/icons/src/components/UserInterfaceIcons/ArrowDown';
import { ArrowUp } from '@bnnvara/icons/src/components/UserInterfaceIcons/ArrowUp';
import React from 'react';

import useUI, { TYPE_TOGGLE_MENU } from '../../../hooks/useUI';
import * as S from './styled';

export function MenuButton() {
  const {
    state: { menuOpen },
    dispatch,
  } = useUI();

  const menuLabel = menuOpen ? 'Menu sluiten' : 'Menu openen';

  return (
    <S.MenuButton
      variant="text"
      onClick={() => {
        track('Hub', 'click', menuLabel);
        dispatch({ type: TYPE_TOGGLE_MENU });
      }}
    >
      Menu {menuOpen ? <ArrowUp /> : <ArrowDown />}
    </S.MenuButton>
  );
}
